import React from "react";

const InvestmentHome = ({
  width = 64,
  height = 64,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="32"
        cy="32"
        r="31"
        fill="#2D96A7"
        fillOpacity="0.1"
        stroke="#2D96A7"
        strokeWidth="2"
      />
      <path
        d="M28.667 34.3336C28.667 35.627 29.667 36.667 30.8937 36.667H33.4003C34.467 36.667 35.3337 35.7603 35.3337 34.627C35.3337 33.4136 34.8003 32.9736 34.0137 32.6936L30.0003 31.2936C29.2137 31.0136 28.6803 30.587 28.6803 29.3603C28.6803 28.2403 29.547 27.3203 30.6136 27.3203H33.1203C34.347 27.3203 35.347 28.3603 35.347 29.6536"
        stroke="#000929"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32 26V38"
        stroke="#000929"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.3337 32.0013C45.3337 39.3613 39.3603 45.3346 32.0003 45.3346C24.6403 45.3346 18.667 39.3613 18.667 32.0013C18.667 24.6413 24.6403 18.668 32.0003 18.668"
        stroke="#2D96A7"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.667 20V25.3333H44.0003"
        stroke="#2D96A7"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.3337 18.668L38.667 25.3346"
        stroke="#2D96A7"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default InvestmentHome;
